module.exports = __webpack_public_path__ + "static/media/unsupported-light.fc4992f0.svg";